import gql from 'graphql-tag'

export const newSubtask = gql`
  mutation newSubtask(
    $name: String!
    $isCompleted: Boolean!
    $minutesTotal: Int
    $minutesSpent: Int
    $progressPercentage: Int
    $taskId: ID!
    $userId: ID!
  ) {
    createSubtask(
      name: $name
      isCompleted: $isCompleted
      minutesTotal: $minutesTotal
      minutesSpent: $minutesSpent
      progressPercentage: $progressPercentage
      taskId: $taskId
      userId: $userId
    ) {
      id
    }
  }
`

export const updateSubtask = gql`
  mutation updateSubtask(
    $name: String!
    $isCompleted: Boolean!
    $minutesTotal: Int
    $minutesSpent: Int
    $progressPercentage: Int
    $taskId: ID!
    $userId: ID!
    $id: ID!
  ) {
    updateSubtask(
      name: $name
      isCompleted: $isCompleted
      minutesTotal: $minutesTotal
      minutesSpent: $minutesSpent
      progressPercentage: $progressPercentage
      taskId: $taskId
      userId: $userId
      id: $id
    ) {
      id
    }
  }
`

export const deleteSubtask = gql`
  mutation deleteSubtask($id: ID!) {
    deleteSubtask(id: $id) {
      id
    }
  }
`



// WEBPACK FOOTER //
// ./src/graphql/mutations/subtask.js